import { useMutation } from "@tanstack/react-query";

import { cardsAPI } from "../cardsAPI.ts";
import { addNewPaymentMethodMutation } from "../helpers";

export const useAddCardMutation = () => {
  return useMutation ({
    mutationKey: ["add-card"],
    mutationFn: ({ signal }: { signal: AbortSignal }) => {
      return addNewPaymentMethodMutation({ addMethod: cardsAPI.addCard, signal });
    },
  });
};
